// Simple monthly financing estimate: price ÷ 60 months, rounded to nearest euro.
// Used for indicative "desde €X/mes" labels across the catalog and detail pages.
// Real APR / TAE is handled in a personalized quote via the financing CTA.
export function calcMonthly(price, months = 60) {
    if (!price || price <= 0) return 0;
    return Math.round(price / months);
}

export function formatEuro(value) {
    return `€${Number(value).toLocaleString("es-ES")}`;
}
